import "es6-shim";
import "./Overview.css";
import * as React from "react";
import { IPatientOverviewProps } from "./Types";
import { AppropriateEditPopup } from "./SubComponents/PatientOverviewPopupEdit";
import {
    EmailsTable,
    AddressesTable,
    DemographicsTable,
    PhoneNumbersTable,
    PreferredPharmacyTable
} from "./SubComponents/PatientOverviewInformationTable";
import { Loader } from "../genericComponents/Loader/Loader";
import { useMediaQuery } from "../../hooks/useMediaQuery.hook";
import TimerManager from "../../services/TimerManager";
import { ClientEventScreen } from "../../dtos/KioskDtos.dtos";

export const PatientOverview = (props: IPatientOverviewProps) => {
    const orientation = useMediaQuery();
    React.useEffect(() => TimerManager.setCurrentScreen(ClientEventScreen.PatientOverview), [])
    const getAppointments = () => {
        if (props.isPersonalModificationOptionActive && props.isPatientInfoChanged) {
            props.putPatientInfoToServer(props.patientInfo);
        } else {
            props.getAppointmentInfoFromServer(props.patientInfo.patientId);
        }
    }
    return (
        <div>
            <AppropriateEditPopup {...props} />
            <div className="row">
                <div className="col-sm-12" style={{ borderBottom: "1px solid #f4f6f9" }}>
                    <h1 className="profile-header">{props.patientInfo.demographics.lastName + ", " + props.patientInfo.demographics.firstName}</h1>
                    {
                        !props.isPersonalModificationOptionActive &&
                        <h3 className="text-center" style={{ color: "red" }}>{props.text.messagesInstructions.PatientInfoIncorrectMessage}</h3>
                    }
                </div>
            </div>
            <div className="patient-data-container">
                <div className="col-sm-12">
                    <DemographicsTable {...props} />
                </div>
                <div className="col-sm-12">
                    <PhoneNumbersTable {...props} orientation={orientation} />
                </div>
                <div className="col-sm-12">
                    <AddressesTable {...props} orientation={orientation} />
                </div>
                <div className="col-sm-12">
                    <EmailsTable {...props} orientation={orientation} />
                </div>
                {
                    props.isPreferredPharmacyOptionActive && (
                        <div className="col-sm-12">
                            <PreferredPharmacyTable {...props} />
                        </div>
                    )
                }
            </div>
            <div className="overview-footer">
                {
                    props.isLoadingSpinnerActive
                        ?
                        <div className="text-center">
                            <Loader />
                        </div>
                        : <div className="text-center">
                            <button
                                className="buttons-white"
                                onClick={props.return}
                            >
                                {props.text.labels.ExitButton}
                            </button>
                            <button
                                className="buttons-blue"
                                onClick={getAppointments}
                            >
                                {
                                    !props.isPersonalModificationOptionActive
                                        ? props.text.labels.NextLabel
                                        : props.text.labels.SubmitButton
                                }
                            </button>
                        </div>
                }
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/PatientOverview/PatientOverview.component.tsx